// Injects Google Analytics 4 / Google Tag Manager / Meta Pixel / custom scripts
// on user-facing pages, driven by the admin-configured analytics_config.
export function injectAnalytics(config) {
  if (!config || !config.analytics_enabled) return;

  if (config.ga4_enabled && config.ga4_measurement_id) {
    const gaScript = document.createElement('script');
    gaScript.async = true;
    gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${config.ga4_measurement_id}`;
    document.head.appendChild(gaScript);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', config.ga4_measurement_id, {
      page_path: window.location.pathname,
    });
  }

  if (config.gtm_enabled && config.gtm_container_id) {
    const gtmScript = document.createElement('script');
    gtmScript.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${config.gtm_container_id}');
    `;
    document.head.appendChild(gtmScript);

    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${config.gtm_container_id}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.insertBefore(noscript, document.body.firstChild);
  }

  if (config.meta_pixel_enabled && config.meta_pixel_id) {
    window.fbq = function fbq() {
      window.fbq.callMethod
        ? window.fbq.callMethod.apply(window.fbq, arguments)
        : window.fbq.queue.push(arguments);
    };
    window._fbq = window._fbq || window.fbq;
    window.fbq.push = window.fbq;
    window.fbq.loaded = true;
    window.fbq.version = '2.0';
    window.fbq.queue = [];

    const fbScript = document.createElement('script');
    fbScript.async = true;
    fbScript.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(fbScript);

    window.fbq('init', config.meta_pixel_id);
    window.fbq('track', 'PageView');
  }

  if (config.custom_head_scripts) {
    const div = document.createElement('div');
    div.innerHTML = config.custom_head_scripts;
    Array.from(div.children).forEach((el) => {
      if (el.tagName === 'SCRIPT') {
        const script = document.createElement('script');
        Array.from(el.attributes).forEach((attr) => script.setAttribute(attr.name, attr.value));
        script.innerHTML = el.innerHTML;
        document.head.appendChild(script);
      } else {
        document.head.appendChild(el.cloneNode(true));
      }
    });
  }

  if (config.custom_body_scripts) {
    const div = document.createElement('div');
    div.innerHTML = config.custom_body_scripts;
    Array.from(div.children).forEach((el) => {
      if (el.tagName === 'SCRIPT') {
        const script = document.createElement('script');
        Array.from(el.attributes).forEach((attr) => script.setAttribute(attr.name, attr.value));
        script.innerHTML = el.innerHTML;
        document.body.appendChild(script);
      } else {
        document.body.appendChild(el.cloneNode(true));
      }
    });
  }
}

export function trackPageView(path) {
  if (window.gtag && window.__ga4Id) {
    window.gtag('config', window.__ga4Id, { page_path: path });
  }
  if (window.fbq) {
    window.fbq('track', 'PageView');
  }
}
